import clsx from "clsx";
import { default as lottie } from "lottie-web/build/player/lottie_light";
import { useEffect, useRef } from "react";

import styles from "./index.module.css";
import animationData from "./loading.json";

export type PreloaderForMccmProps = {
  className?: string;
};

const Loading = () => {
  const animationContainer = useRef(null);

  useEffect(() => {
    if (!animationContainer.current) return;

    const animation = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
    });

    return () => {
      animation.destroy();
    };
  }, []);

  return <div ref={animationContainer} className={styles.loading} />;
};

export const PreloaderForMccm = ({ className }: PreloaderForMccmProps) => {
  return (
    <div className={clsx(styles.container, className)}>
      <Loading />
    </div>
  );
};
